import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { ThemeProvider } from "styled-components";
import AppContextProvider from "./contextProviders/AppContext";
import Events from "./containers/Events";
import PageError from "./components/PageError";
import ErrorPage from "./containers/ErrorPage";
import BookEvent from "./containers/BookEvent";
import Register from "./containers/Register";
import Success from "./containers/Register/Success";
import { baseUrl } from "./utils";
import "./translations";

import theme from "./styles/theme";
import Breadcrumbs from "./components/Breadcrumbs";

function App() {
  return (
    <div className="full" data-css-scope>
      <ThemeProvider theme={theme}>
        <Router basename={baseUrl}>
          <AppContextProvider>
            <Breadcrumbs />
            <PageError />
            <Switch>
              <Route path="/error" component={ErrorPage} exact />
              <Route path="/:storeName?" component={Events} exact />
              <Route path="/redirect/:eventid" component={BookEvent} exact />
              <Route path="/:storeName/:eventid" component={BookEvent} exact />
              <Route
                path="/:storeName/:eventid/register"
                component={Register}
                exact
              />
              <Route
                path="/:storeName/:eventid/register/success"
                component={Success}
                exact
              />
              <Redirect exact push to="/" />
            </Switch>
          </AppContextProvider>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
